import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { __, sprintf } from '@wordpress/i18n';
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import Tag from '../tag';
/**
 * This component displays a 'X more' button that displays a list of items on a popover when clicked.
 *
 * @return { object } -
 */

var ViewMoreList = function ViewMoreList(_ref) {
  var items = _ref.items;
  return createElement(Tag, {
    className: "woocommerce-view-more-list",
    label: sprintf(__('+%d more', 'woocommerce-admin'), items.length - 1),
    popoverContents: createElement("ul", {
      className: "woocommerce-view-more-list__popover"
    }, items.map(function (item, i) {
      return createElement("li", {
        key: i,
        className: "woocommerce-view-more-list__popover__item"
      }, item);
    }))
  });
};

ViewMoreList.propTypes = {
  /**
   * Items to list in the popover
   */
  items: PropTypes.arrayOf(PropTypes.node)
};
ViewMoreList.defaultProps = {
  items: []
};
export default ViewMoreList;
//# sourceMappingURL=index.js.map